export default __webpack_public_path__ + "cec0023387e64beb366babc120fbaba1.svg";